import { tempCard } from 'Stores/CreditCardTransactions/types';
import { expireDateUnmask, spaceRemover } from 'Utils';
import { addCreditCardSchemaInitialValues } from 'Validations';

/**
 * Kullanıcının forma girdiği kartı, kayıt tamamlanana kadar bellekte tutulacak
 * geçici kart nesnesine dönüştürür.
 *
 * ⚠️ Alan adları SDK v1.0.7 modeline taşındı: `Name` → `cardAlias`,
 * `Value1` → `maskedCardNumber`, `ExpireDate` → `expiryDate`, `Cvv` → `cvv`.
 * Bu aşamada kart numarası henüz maskeli değil, düz PAN'dır.
 */
export const userTemporaryCreditCardNormalize = (values: typeof addCreditCardSchemaInitialValues): tempCard => {
  const cardNumber = spaceRemover(values.creditCardNumber);

  return {
    cardAlias: values.cardName,
    // Kart Masterpass'e kaydedilmediği için ham numara ödeme akışında gerekli.
    cardNumber,
    maskedCardNumber: cardNumber,
    // ⚠️ Form değeri `MM/YY` maskeli (`01/30`); Masterpass ise 4 karakterlik `YYAA`
    // bekler (`3001`). Maskeli değer olduğu gibi gönderilirse `directPayment`
    // `CARD_EXPIRATION_DATE_IS_NOT_VALID` ile 400 döner — SDK bu alanı şifrelemez
    // ve dönüştürmez, ham haliyle servise iletir.
    expiryDate: expireDateUnmask(values.expireDate),
    cvv: values.cvv,
  };
};
